export default "__VITE_ASSET__34466ef4__"